import React from 'react';
import { Link } from 'react-router-dom';

import Paragraph from 'pages/Landings/components/Paragraph';

import useStyles from './styles';

interface Props {
    title: React.ReactNode;
    icon: React.ReactNode;
    to: string;
    description?: React.ReactNode;
    className?: string;
    iconClassName?: string;
}

const Card: React.FC<Props> = ({ title, to, icon, description, className, iconClassName }) => {
    const { classes, cx } = useStyles();
    return (
        <Link to={to} className={cx(classes.root, className)}>
            <span className={cx(classes.icon, iconClassName)}>{icon}</span>
            <Paragraph primary={title} secondary={description} />
            <span className={classes.hint}>{'Learn more'}</span>
        </Link>
    );
};

export default Card;
